import { uniq } from "lodash";

export function reMapApplianceRegister(applianceJson) {
  const { cameras, ...appliance } = applianceJson;

  const cameras_only = cameras
    .map((camera) => {
      camera.appliance_id = appliance.appliance_id;
      return camera;
    })
    .sort(compare);

  const payload = {
    appliance: appliance,
    cameras: cameras_only.reduce(function (map, obj) {
      map[obj.camera_id] = obj;
      return map;
    }, {}),
  };

  return payload;
}

function compare(a, b) {
  // Use toUpperCase() to ignore character casing
  const bandA = a.name.toUpperCase();
  const bandB = b.name.toUpperCase();

  let comparison = 0;
  if (bandA > bandB) {
    comparison = 1;
  } else if (bandA < bandB) {
    comparison = -1;
  }
  return comparison;
}

export function reMapGetApplianceData(applianceJson) {
  const appliances = applianceJson.map((app) => {
    const { cameras, ...appliance } = app;
    return appliance;
  });

  let modes_list = [];
  let modes = [];
  const camara_list = applianceJson.map((app) => {
    const { cameras, ...appliance } = app;

    let mods = [];
    cameras
      .filter((camera) => camera.active)
      .forEach((camera) => {
        // console.log(camera.modes[0].mode);
        if (camera.modes[0]) {
          modes.push(camera.modes[0]);
          mods.push(camera.modes[0].mode);
        }
      });
    modes_list = modes_list.concat(mods);

    return cameras
      .map((cam) => {
        cam.appliance_id = appliance.appliance_id;

        return cam;
      })
      .sort(compare);
  });

  const payload = {
    appliances: appliances.reduce(function (map, obj) {
      map[obj.appliance_id] = obj;
      return map;
    }, {}),
    cameras: camara_list
      .reduce((a, b) => a.concat(b), [])
      .reduce(function (map, obj) {
        map[obj.camera_id] = obj;
        return map;
      }, {}),
    modes: uniq(modes_list),
    modes_list: modes.reduce(function (map, obj) {
      map[obj.id] = obj;
      return map;
    }, {}),
  };

  // console.log("modes list");
  // console.log(modes_list);

  return payload;
}

export function reMapEditCameraData(cameraJson, appliance_id) {
  const { modes, ...camera } = cameraJson;
  camera.appliance_id = appliance_id;
  // let final_modes;
  const finalModes = modes.map((mode) => {
    mode.camera_id = camera.camera_id;
    return mode;
  });

  const payload = {
    cameras: camera,
    camera_modes: finalModes.reduce(function (map, obj) {
      map[obj.id] = obj;
      return map;
    }, {}),
  };

  return payload;
}
